/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/bootstrap-daterangepicker@3.1.0/daterangepicker.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
